import request from "@/utils/request";
import store from "@/store/index";
import axios from "axios";
import { getFloorData, getUserInfo } from "@/api/androidApi";

// 获取层数据
export function baseConfig(params) {
  return request({
    url: `/${store.state.app.version_api}/cad/baseConfig`,
    method: "get",
    params,
  });
}

// 获取所有的楼层相关数据--v2
export function getTotalFloorData(type) {
  if (store.state.app.isAndroid) {
    return getFloorData({
      type,
      project_id: store.state.cadModules.rlProject_id || "349",
    });
  }
  return request({
    url: `/api/${store.state.app.version_api}/cad/config`,
    method: "get",
    params: {
      type, // type空默认返回楼层数据 1、floor（楼层） 2、joint（节点） 3、axis（轴线）4、grid（网格）5、BeamSeg（梁布置数据）6、colseg（柱布置数据）7、WallSeg（墙布置数据
      project_id: store.state.cadModules.rlProject_id || "349",
    },
  });
}

//获取dwg数据
export function getDwgData(fileUrl, type = "PKPM") {
  return request({
    url: `${process.env.VUE_APP_DWG_URL}`,
    method: "post",
    data: {
      url: fileUrl,
      type: type,
    },
  });
}

//获取计算结果数据
export function getCalData(type) {
  return request({
    url: `/api/${store.state.app.version_api}/cad/config`,
    method: "get",
    params: {
      type, // 类型 （colsegCalculate，beamsegCalculate，wallsegCalculate）
      project_id: store.state.cadModules.rlProject_id || "2",
      floor_no: store.state.cadModules.rlBuilding.No_ || "1",
    },
  });
}

//获取问题构件列表
export function getProblemComponentsList(project_id) {
  return request({
    url: `/api/${store.state.app.version_api}/problem/list`,
    method: "get",
    params: {
      project_id,
    },
  });
}

// 上报问题构件
export function reportProblemComponents(project_id, data) {
  return request({
    url: `/api/${store.state.app.version_api}/problem/edit`,
    method: "post",
    data: {
      id: project_id,
      data: data,
    },
  });
}
